<template>
  <span
    v-if="text"
    v-c-tooltip="{ content: text, placement: 'top' }"
    class="hr-glossary-tip text-muted ml-1"
    tabindex="0"
    role="img"
    :aria-label="`What is ${term}? ${text}`"
  >
    <CIcon :content="icon" size="sm" />
  </span>
</template>

<script>
// Info icon with the canonical glossary definition (docs/UI-GUIDELINES.md section 7).
// Definitions only, never instructions. Sits next to a label, never wraps the input.
import { cilInfo } from "@coreui/icons";

const GLOSSARY = {
  EPF: "Retirement savings. Employee usually pays 11%; employer pays 12–13%.",
  SOCSO: "Protects employees against work injuries and disability. Rates follow the official table.",
  EIS: "Employment insurance if an employee loses their job. About 0.2% each from employee and employer.",
  PCB: "Monthly income tax deducted from salary and paid to LHDN.",
  Zakat: "Optional religious contribution for Muslim employees, deducted from salary.",
  YTD: "Year to date — total from 1 January until this payslip.",
};

export default {
  name: "HrGlossaryTip",
  props: {
    term: { type: String, required: true },
  },
  data() {
    return { icon: cilInfo };
  },
  computed: {
    text() {
      return GLOSSARY[this.term] || "";
    },
  },
};
</script>

<style scoped>
.hr-glossary-tip {
  cursor: help;
  display: inline-flex;
  vertical-align: middle;
}
</style>
